'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import H4 from 'UIComponents/elements/headings/H4';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const handleOpenChange = evt => {
  if (evt.target.value) {
    UsageTracker.trackEditorInteraction({
      action: 'Approvals Action',
      event: 'viewContentEditorAccessRequestTooltip'
    });
  }
};
const WillUnpublishSoonWarning = ({
  className,
  langKey
}) => /*#__PURE__*/_jsxs(UIAlert, {
  type: "warning",
  className: className,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: `willUnpublishSoonWarning.${langKey}.title`
  }), /*#__PURE__*/_jsx(UIHelpLink, {
    defaultOpen: false,
    showCloseButton: true,
    className: "m-left-2",
    onOpenChange: evt => handleOpenChange(evt),
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "willUnpublishSoonWarning.helpPopoverHeader"
        })
      }),
      body: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `willUnpublishSoonWarning.${langKey}.helpPopoverBody`
        })
      })
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `willUnpublishSoonWarning.${langKey}.helpPopoverLink`
    })
  })]
});
export default WillUnpublishSoonWarning;